module.exports = __webpack_public_path__ + "img/home_imasugu.6bcc1eed.png";